import { useEffect } from "react";

export const UNSAVED_MESSAGE = "You have unsaved changes in Settings. Leave without saving?";

// Unsaved-changes warning: on tab close/reload, and on in-app navigation via
// hash links (sidebar etc. -- the app uses HashRouter without a data router, so
// react-router's useBlocker isn't available).
const useUnsavedChangesGuard = (hasUnsaved) => {
  useEffect(() => {
    if (!hasUnsaved) return undefined;
    const onBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = UNSAVED_MESSAGE;
      return UNSAVED_MESSAGE;
    };
    const onClickCapture = (e) => {
      const link = e.target?.closest?.("a[href]");
      if (!link) return;
      const href = link.getAttribute("href") || "";
      if (!href.startsWith("#/") || href === window.location.hash) return;
      // eslint-disable-next-line no-alert
      if (!window.confirm(UNSAVED_MESSAGE)) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    document.addEventListener("click", onClickCapture, true);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
      document.removeEventListener("click", onClickCapture, true);
    };
  }, [hasUnsaved]);
};

export default useUnsavedChangesGuard;
